export const routes = {
  HOME: "/",
  DASHBOARD: "/dashboard",
  LOGIN: "/login",
  SIGNUP: "/signup",
  QUEUE: "/queque",
  ADMIN: "/aqueue",
  EMPLOYEE: "/payments",
  INVENTORY: "/payments",
  HISTORY: "/reports",
  ACCOUNTS: "/accounts",
  BOOKINGS: "/bookings",
  BK_DAYS: "/by-day",
  BK_MONTHS: "/by-month",
  BK_YEAR: "/by-year",
};
